/**
 * The interval used to update the current session
 * @type { number }
 */
export const SESSION_TIMER_UPDATE = 60000 // 1 minute

/**
 * Default time before (in minutes) we should notify the user that his session is expiring
 * @type { number }
 */
export const SESSION_EXPIRING_DEFAULT_TIMEOUT = 5

/**
 * The factor used to decide how much time before we should notify the user that his session is expiring.
 * @type { number }
 */
export const SESSION_DURATION_FACTOR = 0.2

/**
 * Supported Webhooks
 * @type { array }
 */
export const SUPPORTED_WEBHOOKS = [
    'booking-created',
    'booking-updated',
    'booking-deleted',
    'client-created',
    'client-updated'
]

/**
 * Supported brands
 * @type { Object.<string,string> }
 */
export const BRANDS = {
    EasyPractice: 'easypractice',
    TerapeutBooking: 'terapeut_booking',
    Physica: 'physica',
    Psykbase: 'psykbase',
}

export const CLIENT_APPOINTMENTS_PRINT_SETTINGS = {
    dateTime: true,
    duration: false,
    paidOnly: false,
    services: false,
    paymentDate: true,
    paymentMethod: true,
    paymentAmount: true,
    vat: true,
    includeCancelled: false
}

export const BillableObjectType = {
    Profession: 'profession',
    App: 'app',
    Discount: 'discount',
    Transactional: 'transactional',
}

export const CKEditor_Translations = {
    InsertRowBelow: 'Indsæt række under',
    InsertRowAbove: 'Indsæt række over',
}
